import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { DashboardTitle, DashboardWrapper } from '../../components';
import * as actionCreator from "../../actions";
import Config from '../../models/Config';
import ConfigItem from '../../components/ConfigItem/ConfigItem';
import ConfigItemSkeleton from "../../components/ConfigItem/ConfigItemSkeleton";
import SearchDebounce from '../../components/SearchDebounce/SearchDebounce';


const Administation: React.FC = () => {

    const [t] = useTranslation();
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');

    const { isLoading, data } = useSelector((store: any) => store.configReducer);

    useEffect(() => {
        dispatch(actionCreator.configFetch());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteredConfigs: Config[] = useMemo(() => {
        if (!data) return [];
        if (!search.trim()) return data;
        const q = search.toLowerCase();
        return data.filter((c: Config) =>
            c.key.toLowerCase().includes(q) || c.value.toLowerCase().includes(q)
        );
    }, [data, search]);

    const editableCount: number = useMemo(() =>
        (data ?? []).filter((c: Config) => c.editable === 1).length,
        [data]
    );

    const _renderSkeletons = () =>
        Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="mt-3">
                <ConfigItemSkeleton />
            </div>
        ));

    const _renderContent = () => {
        if (isLoading) return _renderSkeletons();
        if (!data || data.length === 0) return null;

        if (filteredConfigs.length === 0) {
            return (
                <div className="config-page__empty">
                    <i className="iconsminds-search-2" />
                    <p className="mb-0">{t('config_no_results')}</p>
                </div>
            );
        }

        return filteredConfigs.map((config: Config) => (
            <ConfigItem key={config.id} config={config} />
        ));
    };

    return (
        <DashboardWrapper>
            <DashboardTitle
                title={t('Administration')}
                isLoading={isLoading}
                withRefreshIcon={!isLoading}
                refreshIconCallBack={() => dispatch(actionCreator.configFetch())}
            />

            {!isLoading && data && (
                <div className="config-page__toolbar">
                    <div className="config-page__search">
                        <SearchDebounce
                            placeholder={t('config_search_placeholder')}
                            onChange={setSearch}
                        />
                    </div>
                    <div className="config-page__meta">
                        {data.length} {t('config_total')} &middot; {editableCount} {t('Editable').toLowerCase()}
                    </div>
                </div>
            )}

            {_renderContent()}
        </DashboardWrapper>
    );

};

export default React.memo(Administation);
